import React from "react";
import Layout from "../components/layout";
import Head from "../components/head";


export default () => (
    <Layout>
        <Head title="aboutme" />
        <h1>About me</h1>
        <p>I am Saintil dit Laguerre donfred, security expert. I am passionate about technologies and today I am about to enter the professional world.</p>
        <p>Getting my hands dirty is particularly enchanting to me. . I also believe that the process, <strike>the path taken to find</strike>, is just as exciting as the end result.</p>
        <p>One of my favorite things to do is take my passion for design and love for coding and combine them in my projects. I'm obssessed with gorgeous UI's; designing my own (for clients or otherwise) is so satisfying. And then translating that into code and crafting a truly memorable UX is my passion.</p>
        <p> I live in Paris, CA but my goal is to move to Chicago, IL someday soon. Some would say that's a downgrade, at least in weather quality, but I'm focused as hell to get there. If you're from Chicago, I'd love to hear from you!</p>
        <p>Some hobbies of mine include music and sports. </p>
        
        
    </Layout>
)